import { Ingredient } from './Ingredient'
import data from './imported-data'
import { convertDataToIngredients } from './data-utils'

const ingredients = convertDataToIngredients(data) as Ingredient[]
export default ingredients
